<template>
  <div class="modal-addressedit">
    <a-modal
      v-model="showModal"
      :footer="null"
      crm_at="modal_addressedit"
      class="modal-EditAddress"
      centered
      :after-close="ModalClose"
    >
      <div :class="currentLocale">
        <div class="row">
          <div class="col-12 text-center">
            <label crm_at="label_addressedit" class="label-address">
              {{ lbl.address.edit }}
            </label>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-12">
            <div class="address-edit-list">
              <a-form
                :form="form"
                :label-col="{ span: 5 }"
                :wrapper-col="{ span: 12 }"
                @submit="handleSubmit"
              >
                <a-form-item
                  :label="lbl.shipping.firstname.name"
                  crm_at="label_firstname"
                >
                  <a-input
                    v-decorator="['firstName']"
                    :placeholder="lbl.shipping.firstname.name"
                    crm_at="firstname"
                    @change="
                      e => {
                        chcekFirstName(e.target.value)
                      }
                    "
                  />
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.lastname.name"
                  crm_at="label_lastname"
                >
                  <a-input
                    v-decorator="['lastName']"
                    :placeholder="lbl.shipping.lastname.name"
                    crm_at="lastname"
                    @change="
                      e => {
                        chcekLastName(e.target.value)
                      }
                    "
                  />
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.address.name"
                  crm_at="label_address"
                >
                  <a-textarea
                    v-decorator="['streetaddress']"
                    crm_at="address"
                    :placeholder="lbl.shipping.address.name"
                    @change="checkAddressName"
                  />
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.zipcode.name"
                  crm_at="label_zipcode"
                >
                  <a-input
                    v-decorator="['zipCode']"
                    :max-length="5"
                    :placeholder="lbl.shipping.zipcode.name"
                    crm_at="zipcode"
                    @keypress="onlyNumber"
                    @change="chcekfillformattel"
                  />
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.province.name"
                  crm_at="label_province"
                >
                  <a-select
                    v-decorator="['province']"
                    :placeholder="lbl.shipping.province.placeholder"
                    crm_at="select_province"
                    @change="handleSelectChangeProvince"
                  >
                    <a-select-option
                      v-for="(option, keyOption) in listProvinceforShow"
                      :key="keyOption"
                      crm_at="province"
                      :value="option.provinceCode"
                    >
                      {{
                        islocalethai
                          ? option.provinceName
                          : option.provinceNameEN
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.district.name"
                  crm_at="label_district"
                >
                  <a-select
                    v-decorator="['district']"
                    :placeholder="lbl.shipping.district.placeholder"
                    crm_at="select_district"
                    @change="handleSelectChangeDistrict"
                  >
                    <a-select-option
                      v-for="(option, keyOption) in listDistrictforShow"
                      :key="keyOption"
                      crm_at="district"
                      :value="option.districtCode"
                    >
                      {{
                        islocalethai
                          ? option.districtName
                          : option.districtNameEN
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item
                  :label="lbl.shipping.subdistrict.name"
                  crm_at="label_subdistrict"
                >
                  <a-select
                    v-decorator="['subdistrict']"
                    :placeholder="lbl.shipping.subdistrict.placeholder"
                    crm_at="select_subdistrict"
                    @change="handleSelectChangeSubdistrict"
                  >
                    <a-select-option
                      v-for="(option, keyOption) in listSubDistrictforShow"
                      :key="keyOption"
                      crm_at="subdistrict"
                      :value="option.subdistrictCode"
                    >
                      {{
                        islocalethai
                          ? option.subdistrictName
                          : option.subdistrictNameEN
                      }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item
                  :label="lbl.myprofile.tel.name"
                  crm_at="label_mobile_number"
                >
                  <a-input
                    v-decorator="['mobileNumber']"
                    type="tel"
                    :placeholder="lbl.myprofile.tel.name"
                    crm_at="mobilenumber"
                    @keypress="onlyNumber"
                    @keyup="keyUp"
                    @change="
                      e => {
                        chcekMobileNumber(e.target.value)
                      }
                    "
                  />
                </a-form-item>

                <!-- Tax No. -->
                <a-form-item
                  v-if="taxDetail.display"
                  :label="lbl.shipping.tax.id"
                  crm_at="label_tax_id"
                  class="mt-3"
                >
                  <a-input
                    v-decorator="['TaxNo']"
                    :placeholder="lbl.shipping.tax.placeholder"
                    crm_at="tax_id"
                    :max-length="lengthCitizen"
                    @change="
                      e => {
                        changeTaxNo(e.target.value)
                      }
                    "
                  />
                </a-form-item>

                <div class="text-center pb-2">
                  <a-button
                    type="primary"
                    html-type="submit"
                    shape="round"
                    class="btn-crm-xl w-70"
                    :style="{
                      'background-color': backgroundColor
                        ? backgroundColor
                        : '#1890ff',
                      'border-color': backgroundColor
                        ? backgroundColor
                        : '#1890ff',
                    }"
                    crm_at="btn_save"
                    :class="{
                      disable: disableSubmit,
                    }"
                  >
                    <span
                      class="label-save"
                      crm_at="label_save"
                      :style="{ color: textColor ? textColor : '#FFF' }"
                      >{{ lbl.btn.save }}</span
                    >
                  </a-button>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <AlertError
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
  </div>
</template>

<script>
import CommonMixin from '@/mixin/CommonMixin'
import BzbsDashboard from '@/core/Home/BzbsDashboard'
import BzbsProfile from '@/core/Account/service/BzbsProfile'
import Account from '@/helper/AccountHelper.js'
import Locale from '@/helper/Locale.js'
import moment from 'moment'
import BzbsHistory from '@/core/Account/service/BzbsHistory'
import HelperProvince from '@/helper/model/ZipcodeModel.js'
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign'
import _ from 'lodash'
import AlertError from '@/components/Modal/AlertError'
import Vue from 'vue'

export default {
  components: { AlertError },
  mixins: [CommonMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      showModal: false,
      form: this.$form.createForm(this, { name: 'coordinated' }),
      currentLocale: Locale.getLocale(),
      backgroundColor: '',
      textColor: '',
      listProvinceforShow: [],
      listDistrictforShow: [],
      listSubDistrictforShow: [],
      islocalethai: false,
      objProfileUser: [],
      objProfileInfo: [],
      objProfileShipping: [],
      strExtendJson: {},
      showError: false,
      dataError: {},
      addressName: '',
      FirstName: '',
      LastName: '',
      MobileNumber: '',
      isAddressNameNotnull: false,
      iszipCodeNotnull: false,
      isprovinceNotnull: false,
      isdistrictNotnull: false,
      issubDistrictNotnull: false,
      isFirstNameNotnull: false,
      isLastNameNotnull: false,
      isMobileNumberNotnull: false,
      TaxNo: '',
      isTaxNoNotnull: true,
      lengthMobile: 10,
      lengthCitizen: 13,
      taxDetail: {},
    }
  },
  computed: {
    disableSubmit() {
      return (
        !this.isFirstNameNotnull ||
        !this.isLastNameNotnull ||
        !this.isAddressNameNotnull ||
        !this.iszipCodeNotnull ||
        !this.isprovinceNotnull ||
        !this.isdistrictNotnull ||
        !this.issubDistrictNotnull ||
        !this.isMobileNumberNotnull ||
        this.isTaxNoNotnull
      )
    },
  },
  watch: {
    show(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getCustomerStore().then(() => {
          this.init()
          this.genInfo(newVal)
        })
      }
    },
  },
  created() {},
  methods: {
    init() {
      moment.locale(Locale.getLocale())
      if (moment.locale(Locale.getLocale()) == 'th') {
        this.islocalethai = true
      }

      this.lengthMobile = Vue.bzbsConfig.businessRule.max.phoneLength

      this.getprofileinit().then(res => {
        console.log('getprofileinit : ', res)
        this.objProfileUser = res
        this.addressName = this.objProfileUser.Address
          ? this.objProfileUser.Address
          : ''
        this.FirstName = this.objProfileUser.FirstName
          ? this.objProfileUser.FirstName
          : ''
        this.LastName = this.objProfileUser.LastName
          ? this.objProfileUser.LastName
          : ''
        this.districtForSave = this.objProfileUser.DistrictCode
        this.isdistrictNotnull = this.districtForSave ? true : false
        this.subDistrictForSave = this.objProfileUser.SubDistrictCode
        this.issubDistrictNotnull = this.subDistrictForSave ? true : false
        this.MobileNumber = this.objProfileUser.Contact_Number
          ? this.objProfileUser.Contact_Number
          : ''
        this.TaxNo = this.objProfileUser.NationalIdCard
          ? this.objProfileUser.NationalIdCard
          : ''
        this.listSubDistrictForSearch = this.objProfileUser.SubDistrictCode
          ? true
          : false
        this.listDistrictForSearch = this.objProfileUser.DistrictCode
          ? true
          : false
        this.isAddressNameNotnull = this.addressName ? true : false
        if (this.objProfileUser.Zipcode) {
          this.getInfoPostcode(this.objProfileUser.Zipcode)
        }
        this.form.setFieldsValue({
          streetaddress: `${
            this.objProfileUser.Address ? this.objProfileUser.Address : ''
          }`,
          zipCode: `${
            this.objProfileUser.Zipcode ? this.objProfileUser.Zipcode : ''
          }`,
          firstName: `${
            this.objProfileUser.FirstName ? this.objProfileUser.FirstName : ''
          }`,
          lastName: `${
            this.objProfileUser.LastName ? this.objProfileUser.LastName : ''
          }`,
          mobileNumber: `${
            this.objProfileUser.Contact_Number
              ? this.objProfileUser.Contact_Number
              : ''
          }`,
          TaxNo: `${
            this.objProfileUser.NationalIdCard
              ? this.objProfileUser.NationalIdCard
              : ''
          }`,
        })
        this.isFirstNameNotnull = this.objProfileUser.FirstName ? true : false
        this.isMobileNumberNotnull = this.objProfileUser.Contact_Number
          ? true
          : false
        this.isLastNameNotnull = this.objProfileUser.LastName ? true : false
        this.iszipCodeNotnull = this.objProfileUser.Zipcode ? true : false
        this.handleLoading(false)
        console.log(this.objProfileUser)
      })
    },
    genInfo(isShow) {
      this.showModal = isShow
    },
    ModalClose() {
      this.showModal = false
      let data = {
        show: false,
        success: false,
      }
      this.$emit('changeAddress', data)
    },
    getCustomerStore() {
      this.handleLoading(true)

      return new Promise(resolve => {
        BzbsDashboard.getCustomerStore()
          .then(res => {
            this.handleLoading(false)
            this.genCustomerStore(res.data)
            resolve(res.data)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('getCustomerStore error', error)
            resolve(error)
          })
      })
    },
    genCustomerStore(data) {
      this.backgroundColor = data.StoreDetail.ButtonColor
      this.textColor = data.StoreDetail.ButtonTextColor

      this.taxDetail.display = data.StoreDetail.IsCitizenId
      this.taxDetail.required = data.StoreDetail.IsCitizenIdRequiredField
      this.changeTaxNo(this.TaxNo)
    },
    onlyNumber($event) {
      const regex = /^[0-9]\d*$/
      var match = $event.key.match(regex)

      if (match == null) {
        $event.preventDefault()
      }
    },
    keyUp($event) {
      if ($event.target.value) {
        var thenum = $event.target.value
          .replace(/\D/g, '')
          .slice(0, parseInt(this.lengthMobile))
        this.form.setFieldsValue({
          mobileNumber: thenum,
        })
      }
    },
    getprofileinit() {
      return new Promise(resolve => {
        BzbsProfile.getProfile(Account.getCacheToken())
          .then(res => {
            resolve(res.data)
          })
          .catch(error => {
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log(error)
            resolve(error)
          })
      })
    },
    chcekFirstName(value) {
      this.FirstName = value

      if (value != '') {
        this.isFirstNameNotnull = true
      } else {
        this.isFirstNameNotnull = false
      }
    },
    chcekMobileNumber(value) {
      this.MobileNumber = value

      if (value != '') {
        this.isMobileNumberNotnull = true
      } else {
        this.isMobileNumberNotnull = false
      }
    },
    chcekLastName(value) {
      this.LastName = value

      if (value != '') {
        this.isLastNameNotnull = true
      } else {
        this.isLastNameNotnull = false
      }
    },
    checkAddressName(e) {
      var value = e.target.value
      var fn = value
      var regex = /[-!$@฿#%^&*()_+|~=`{}[\]:";'<>?]+$/
      var isregex = regex.test(fn)
      var checklength = value.length
      if (isregex) {
        var ztoontest2Search = value.substring(0, checklength - 1)
        this.addressName = ztoontest2Search
      }
      if (checklength > 0) {
        this.isAddressNameNotnull = true
      } else {
        this.isAddressNameNotnull = false
      }
    },
    chcekfillformattel(event) {
      this.listProvinceforShow = []
      this.listDistrictforShow = []
      this.listSubDistrictforShow = []
      this.listSubDistrict = []
      this.iszipCodeNotnull = false
      this.isprovinceNotnull = false
      this.isdistrictNotnull = false
      this.issubDistrictNotnull = false
      this.form.setFieldsValue({
        province: this.lbl.shipping.province.placeholder,
        district: this.lbl.shipping.district.placeholder,
        subdistrict: this.lbl.shipping.subdistrict.placeholder,
      })
      var value = event.target.value
      if (value.length > 4) {
        this.iszipCodeNotnull = true
        this.getInfoPostcode(value)
      } else {
        this.iszipCodeNotnull = false
      }
    },
    getInfoPostcode(value) {
      this.getPostcode(value).then(res => {
        if (res.listProvince) {
          this.listProvinceforShow = res.listProvince
          this.provinceForSave = this.listProvinceforShow[0].provinceCode
          this.isprovinceNotnull = true
          this.form.setFieldsValue({
            province: `${
              this.islocalethai
                ? this.listProvinceforShow[0].provinceName
                : this.listProvinceforShow[0].provinceNameEN
            }`,
          })
        }
        if (res.listDistrict) {
          this.listDistrictforShow = res.listDistrict
          if (this.listDistrictforShow.length == 2) {
            this.districtForSave = this.listDistrictforShow[1].districtCode
            this.listSubDistrictforShow = res.listSubDistrict
            this.isdistrictNotnull = true
            this.form.setFieldsValue({
              district: `${
                this.islocalethai
                  ? this.listDistrictforShow[1].districtName
                  : this.listDistrictforShow[1].districtNameEN
              }`,
            })
            if (this.listSubDistrictForSearch) {
              this.listSubDistrictForSearch = false
              for (var i = 0; i < this.listSubDistrictforShow.length; i++) {
                if (
                  this.objProfileUser.SubDistrictCode ==
                  this.listSubDistrictforShow[i].subdistrictCode
                ) {
                  var subDistrictName = this.listSubDistrictforShow[i]
                    .subdistrictName
                  var subdistrictNameEN = this.listSubDistrictforShow[i]
                    .subdistrictNameEN
                  this.form.setFieldsValue({
                    subdistrict: `${
                      this.islocalethai ? subDistrictName : subdistrictNameEN
                    }`,
                  })
                }
              }
            }
          } else {
            this.listSubDistrict = res.listSubDistrict
            this.listSubDistrictforShow = _.filter(
              res.listSubDistrict,
              item => {
                if (item.districtCode == this.objProfileUser.DistrictCode)
                  return item
              },
            )
            this.form.setFieldsValue({
              district: `${
                this.islocalethai
                  ? this.listDistrictforShow[0].districtName
                  : this.listDistrictforShow[0].districtNameEN
              }`,
              subdistrict: `${
                this.islocalethai
                  ? this.listSubDistrict[0].subdistrictName
                  : this.listSubDistrict[0].subdistrictNameEN
              }`,
            })
            if (this.listDistrictForSearch) {
              this.listDistrictForSearch = false
              for (var k = 0; k < this.listDistrictforShow.length; k++) {
                if (
                  this.objProfileUser.DistrictCode ==
                  this.listDistrictforShow[k].districtCode
                ) {
                  var districtName = this.listDistrictforShow[k].districtName
                  var districtNameEN = this.listDistrictforShow[k]
                    .districtNameEN
                  this.form.setFieldsValue({
                    district: `${
                      this.islocalethai ? districtName : districtNameEN
                    }`,
                  })
                }
              }
            }
            if (this.listSubDistrictForSearch) {
              this.listSubDistrictForSearch = false
              for (var j = 0; j < this.listSubDistrict.length; j++) {
                if (
                  this.objProfileUser.SubDistrictCode ==
                  this.listSubDistrict[j].subdistrictCode
                ) {
                  var subDistrict_Name = this.listSubDistrict[j].subdistrictName
                  var subdistrict_NameEN = this.listSubDistrict[j]
                    .subdistrictNameEN
                  this.form.setFieldsValue({
                    subdistrict: `${
                      this.islocalethai ? subDistrict_Name : subdistrict_NameEN
                    }`,
                  })
                }
              }
            }
          }
        }
      })
    },
    handleSelectChangeProvince(value) {
      this.provinceForSave = value
      if (value !== '0') {
        this.isprovinceNotnull = true
      } else {
        this.isprovinceNotnull = false
      }
    },
    handleSelectChangeDistrict(value) {
      this.issubDistrictNotnull = false
      this.districtForSave = value
      const words = this.listSubDistrict
      this.listSubDistrictforShow = words.filter(
        word => word.districtCode == value || word.districtCode == 0,
      )
      this.form.setFieldsValue({
        subdistrict: this.lbl.shipping.subdistrict.placeholder,
      })
      if (value !== '0') {
        this.isdistrictNotnull = true
      } else {
        this.isdistrictNotnull = false
      }
    },
    handleSelectChangeSubdistrict(value) {
      this.subDistrictForSave = value
      if (value !== '0') {
        this.issubDistrictNotnull = true
      } else {
        this.issubDistrictNotnull = false
      }
    },
    getPostcode(value) {
      return new Promise(resolve => {
        BzbsHistory.getPostcode(value)
          .then(res => {
            if (res.data.length > 0) {
              var listProvince = []
              var listDistrict = [
                {
                  districtCode: '0',
                  districtName: this.lbl.shipping.district.placeholder,
                  districtNameEN: this.lbl.shipping.district.placeholder,
                  provinceCode: '0',
                },
              ]
              var listSubDistrict = [
                {
                  districtCode: '0',
                  subdistrictCode: '0',
                  subdistrictName: this.lbl.shipping.subdistrict.placeholder,
                  subdistrictNameEN: this.lbl.shipping.subdistrict.placeholder,
                },
              ]
              var zipcodeList = []
              for (var i = 0; i < res.data.length; i++) {
                var prov = new HelperProvince.ProvinceModel(res.data[i])
                var isDuplicateProvince = false
                for (var j = 0; j < listProvince.length; j++) {
                  if (listProvince[j].provinceNameEN == prov.provinceNameEN) {
                    isDuplicateProvince = true
                    break
                  }
                }
                if (!isDuplicateProvince) {
                  listProvince.push(prov)
                }
                var dis = new HelperProvince.DistrictModel(res.data[i])
                var isDuplicateDistrict = false
                for (var k = 0; k < listDistrict.length; k++) {
                  if (listDistrict[k].districtNameEN == dis.districtNameEN) {
                    isDuplicateDistrict = true
                    break
                  }
                }

                if (!isDuplicateDistrict) {
                  listDistrict.push(dis)
                }

                var subDis = new HelperProvince.SubDistrictModel(res.data[i])
                var isDuplicateSubDistrict = false
                for (var l = 0; l < listSubDistrict.length; l++) {
                  if (
                    listSubDistrict[l].subdistrictNameEN ==
                    subDis.subdistrictNameEN
                  ) {
                    isDuplicateSubDistrict = true
                    break
                  }
                }

                if (!isDuplicateSubDistrict) {
                  listSubDistrict.push(subDis)
                }
              }
            } else {
              this.showError = true
              this.dataError = {
                title: this.lbl.error.errortitle,
                detail: this.lbl.error.connectionproblem,
              }
            }
            zipcodeList.listProvince = listProvince
            zipcodeList.listDistrict = listDistrict
            zipcodeList.listSubDistrict = listSubDistrict
            console.log(zipcodeList)
            resolve(zipcodeList)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            resolve(error)
          })
      })
    },
    updateProfileShipping() {
      this.handleLoading(true)
      return new Promise(resolve => {
        BzbsProfile.updateShippingAddress(
          Account.getCacheToken(),
          this.objProfileShipping,
        )
          .then(res => {
            this.handleLoading(false)
            console.log(res)
            resolve(res)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log('updateShippingAddress', error)
            resolve(error)
          })
      })
    },
    postRedeem() {
      this.handleLoading(true)

      var address =
        this.objProfileUser.Address +
        ' ' +
        this.objProfileUser.SubDistrictName +
        ' ' +
        this.objProfileUser.DistrictName +
        ' ' +
        this.objProfileUser.ProvinceName +
        ' ' +
        this.objProfileUser.Zipcode +
        ' ID ' +
        this.objProfileUser.NationalIdCard

      let params = {
        firstname: this.FirstName,
        lastname: this.LastName,
        shippingFirstName: this.FirstName,
        shippingLastName: this.LastName,
        contact_number: this.MobileNumber,
        email: this.objProfileUser.Email,
        address: address,
        zipcode: this.objProfileAdress.strZipcode,
        info3: this.objProfileShipping.strNationalIdCard,
      }
      return new Promise(resolve => {
        BzbsCampaign.postCampaign(this.$route.params.Id, params)
          .then(res => {
            this.handleLoading(false)
            console.log(res)
            this.showModal = false
            let data = {
              show: false,
              success: true,
            }
            this.$emit('changeAddress', data)
            resolve(res)
          })
          .catch(error => {
            this.handleLoading(false)
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: error.response.data.error.message,
            }
            console.log(error)
            resolve(error)
          })
      })
    },
    changeTaxNo(value) {
      this.TaxNo = value
      console.log(value)
      if (this.taxDetail.display) {
        if (this.taxDetail.required) {
          if (value != '') {
            this.validateInput(this.TaxNo.replace(/-/g, ''))
          } else {
            this.isTaxNoNotnull = true
          }
        } else {
          if (value != '') {
            this.validateInput(this.TaxNo.replace(/-/g, ''))
          } else {
            this.isTaxNoNotnull = false
          }
        }
      } else {
        this.isTaxNoNotnull = false
      }
    },
    validateInput(value) {
      const maxLength = 13
      const regex = /^[0-9]\d*$/
      if (
        value !== undefined &&
        value.length === maxLength &&
        value.match(regex) &&
        this.validNationalID(value)
      ) {
        this.isTaxNoNotnull = false
      } else if (
        value !== undefined &&
        value.length === maxLength &&
        value.match(regex) &&
        !this.validNationalID(value)
      ) {
        this.isTaxNoNotnull = true
      } else {
        this.isTaxNoNotnull = true
      }
    },
    validNationalID(id) {
      if (id == null || id.length !== 13) return false
      let i
      let sum = 0
      for (i = 0, sum = 0; i < 12; i++) {
        sum += parseInt(id.charAt(i)) * (13 - i)
      }
      const mod = sum % 11
      const check = (11 - mod) % 10
      if (check === parseInt(id.charAt(12))) {
        return true
      }
      return false
    },

    handleSubmit(e) {
      e.preventDefault()

      this.form.validateFields((err, values) => {
        console.log('validateFields : ', values)
        this.objProfileAdress = []
        this.objProfileAdress.strAddress = values.streetaddress
          ? values.streetaddress
          : ''
        this.objProfileAdress.strZipcode = values.zipCode ? values.zipCode : ''
        this.objProfileAdress.strProvinceCode = this.provinceForSave
          ? this.provinceForSave
          : ''
        this.objProfileAdress.strDistrictCode = this.districtForSave
          ? this.districtForSave
          : ''
        this.objProfileAdress.strSubDistrictCode = this.subDistrictForSave
          ? this.subDistrictForSave
          : ''

        if (this.listProvinceforShow.length > 0) {
          _.filter(this.listProvinceforShow, item => {
            if (item.provinceCode == this.provinceForSave) {
              if (Locale.getLocale() == 'th') {
                var name = item.provinceName.toString()
                this.objProfileAdress.strProvinceName = name
              } else {
                var nameEn = item.provinceNameEN.toString()
                this.objProfileAdress.strProvinceName = nameEn
              }
            }
          })
        } else {
          this.objProfileAdress.strProvinceName = this.objProfileUser.ProvinceName
        }

        if (this.listDistrictforShow.length > 0) {
          _.filter(this.listDistrictforShow, item => {
            if (item.districtCode == this.districtForSave) {
              if (Locale.getLocale() == 'th') {
                var name = item.districtName.toString()
                this.objProfileAdress.strDistrictName = name
              } else {
                var nameEn = item.districtNameEN.toString()
                this.objProfileAdress.strDistrictName = nameEn
              }
            }
          })
        } else {
          this.objProfileAdress.strDistrictName = this.objProfileUser.DistrictCode
        }
        if (this.listSubDistrictforShow.length > 0) {
          _.filter(this.listSubDistrictforShow, item => {
            if (item.subdistrictCode == this.subDistrictForSave) {
              if (Locale.getLocale() == 'th') {
                var name = item.subdistrictName.toString()
                this.objProfileAdress.strSubDistrictName = name
              } else {
                var nameEn = item.subdistrictNameEN.toString()
                this.objProfileAdress.strSubDistrictName = nameEn
              }
            }
          })
        } else {
          this.objProfileAdress.strSubDistrictName = this.objProfileUser.SubDistrictName
        }
        if (
          this.objProfileAdress.strAddress == '' ||
          this.objProfileAdress.strZipcode == '' ||
          this.objProfileAdress.strProvinceCode == '' ||
          this.objProfileAdress.strDistrictCode == '' ||
          this.objProfileAdress.strSubDistrictCode == '' ||
          this.objProfileAdress.strProvinceCode == 0 ||
          this.objProfileAdress.strDistrictCode == 0 ||
          this.objProfileAdress.strSubDistrictCode == 0 ||
          this.objProfileAdress.strProvinceCode == '0' ||
          this.objProfileAdress.strDistrictCode == '0' ||
          this.objProfileAdress.strSubDistrictCode == '0'
        ) {
          return
        } else {
          this.handleLoading(true)

          this.objProfileShipping.strNationalIdCard = this.TaxNo
            ? this.TaxNo
            : ''
          this.objProfileShipping.strAddress = this.objProfileAdress.strAddress
            ? this.objProfileAdress.strAddress
            : ''
          this.objProfileShipping.strZipcode = this.objProfileAdress.strZipcode
            ? this.objProfileAdress.strZipcode
            : ''
          this.objProfileShipping.strProvinceCode = this.objProfileAdress
            .strProvinceCode
            ? this.objProfileAdress.strProvinceCode
            : ''
          this.objProfileShipping.strProvinceName = this.objProfileAdress
            .strProvinceName
            ? this.objProfileAdress.strProvinceName
            : ''
          this.objProfileShipping.strDistrictCode = this.objProfileAdress
            .strDistrictCode
            ? this.objProfileAdress.strDistrictCode
            : ''
          this.objProfileShipping.strDistrictName = this.objProfileAdress
            .strDistrictName
            ? this.objProfileAdress.strDistrictName
            : ''
          this.objProfileShipping.strSubDistrictCode = this.objProfileAdress
            .strSubDistrictCode
            ? this.objProfileAdress.strSubDistrictCode
            : ''
          this.objProfileShipping.strSubDistrictName = this.objProfileAdress
            .strSubDistrictName
            ? this.objProfileAdress.strSubDistrictName
            : ''

          this.objProfileShipping.strFirstName = this.FirstName
            ? this.FirstName
            : ''
          this.objProfileShipping.strLastName = this.LastName
            ? this.LastName
            : ''
          this.objProfileShipping.strContactNumber = this.MobileNumber
            ? this.MobileNumber
            : ''
          this.objProfileShipping.strEmail = this.objProfileUser.Email
            ? this.objProfileUser.Email
            : ''

          this.updateProfileShipping().then(() => {
            this.postRedeem()
          })
        }
      })
    },

    //Error
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
  },
}
</script>

<style lang="scss">
.modal-EditAddress {
  .label-address {
    font-weight: 700 !important;
    color: #666 !important;
  }

  .ant-form-item label {
    font-weight: 700 !important;
    font-size: 17px;
    color: #666 !important;
  }

  .disable {
    border-color: #e5e5e5 !important;
    background-color: #e5e5e5 !important;
    color: #999 !important;
    pointer-events: none;
  }

  @media only screen and (min-device-width: 600px) {
    .ant-modal {
      width: 90% !important;
    }
  }

  @media only screen and (min-device-width: 901px) {
    .ant-modal {
      width: 675px !important;
    }
  }
}
.label-save {
  font-size: 18px;
  font-weight: 500;
}
</style>
